import Promise from 'promise-polyfill'

const BusinessTripRequestEmployee = {
  namespaced: true,
  mutations: {
    reset: (state, payload) => {
    }
  },
  actions: {
    getEmployees: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestEmployee.getBtRequestEmployeeUsingGET({id: payload.id})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    getNewEmployee: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestEmployee.addNewBtRequestEmployeeUsingGET()
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    getEmpTracking: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestEmployee.getBtRequestEmployeeTrackingUsingGET({id: payload.id, empid: payload.empid})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    validateEmployee: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestEmployee.validateBtRequestEmployeeUsingPOST({org: payload.orgid, emp: payload.emp})
          .then(res => resolve(res.body)).catch(err => reject(err))
      })
    },
    addEmployee: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        const emp = payload.emp
        // id if exists
        if (typeof emp.id !== 'undefined') { delete emp.id }
        vue.$backend.businessTripRequestEmployee.insertBtRequestEmployeeUsingPOST({id: payload.id, emp: payload.emp})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    deleteEmployee: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestEmployee.deleteBtRequestEmployeeUsingDELETE({id: payload.id, empid: payload.empid})
          .then(res => {
            resolve()
          })
          .catch(err => reject(err))
      })
    },
    getEmployeeById: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestEmployee.getBtRequestEmployeeByIdUsingGET({id: payload.id, empid: payload.empid})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    updateEmployee: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestEmployee.updateBtRequestEmployeeUsingPUT({id: payload.id,
          empid: payload.emp.id,
          emp: payload.emp})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    printSppd: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestEmployee
          .printBtRequestSppdUsingGET({id: payload.id, empid: payload.empid})
          .then(res => resolve(res.data)).catch(err => reject(err))
      })
    },
    printSprpd: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequestEmployee
          .printBtRequestSprpdUsingGET({id: payload.id, empid: payload.empid})
          .then(res => resolve(res.data)).catch(err => reject(err))
      })
    },
    reset: (context, payload) => {
      context.commit('reset', payload)
    }
  }
}

export default BusinessTripRequestEmployee



// WEBPACK FOOTER //
// ./src/store/business-trip-request/BusinessTripRequestEmployee.js